import smoothscroll from 'smoothscroll-polyfill';

const scroll = {
  links: document.querySelectorAll('a[href^="#"]'),
};

function intoView(event) {
  event.preventDefault();
  let target = this.getAttribute('href');
  target = target.replace('#', '');
  document.getElementById(target).scrollIntoView({ behavior: 'smooth' });
}

export default function InitAnchorClicks() {
  // kick off the polyfill!
  smoothscroll.polyfill();

  // Add event listeners
  for (let i = scroll.links.length - 1; i >= 0; i -= 1) {
    scroll.links[i].addEventListener('click', intoView, false);
  }
}



// WEBPACK FOOTER //
// ./src/scripts/modules/anchorscroll.js